import { makeApiError, makeApiSuccess } from 'scenes/common/helpers/apiData';
import {
  ApiData,
  RecentInsurerOptions,
  RefDataType,
} from 'scenes/common/types';
import { WireRefDataType, WireRefDataTypes } from './types';

export const unmarshalRefData = (
  referenceData: WireRefDataTypes
): ApiData<RefDataType[]> => {
  const referenceDataList = Object.values(referenceData);
  return referenceDataList.length > 0
    ? makeApiSuccess(
        referenceDataList
          .map((refData) => ({
            value: refData.code,
            label: refData.value,
            order: Number(refData.order ?? 0),
            flagname: refData.flagname,
          }))
          .sort(
            (a: RefDataType, b: RefDataType) => (a.order ?? 0) - (b.order ?? 0)
          )
      )
    : makeApiError('Not found');
};

export const isMostCommon = (insurer: WireRefDataType) =>
  insurer.flagname?.toLowerCase() === 'mostcommon';

export const toInsurer = (insurer: WireRefDataType) => ({
  label: insurer.value,
  value: insurer.code,
});

export const byCode = (a: WireRefDataType, b: WireRefDataType) =>
  a.code.localeCompare(b.code);

const toRecentInsurerOptions = (
  insurers: WireRefDataType[]
): RecentInsurerOptions => ({
  dontKnowOption: insurers
    .map(toInsurer)
    .find((insurer) => insurer.value.toLowerCase() === 'dontknow') || {
    label: "Don't know",
    value: 'dontknow',
  },

  otherOption: insurers
    .map(toInsurer)
    .find((insurer) => insurer.value.toLowerCase() === 'other') || {
    label: 'Other',
    value: 'Other',
  },

  notInsuredOption: insurers
    .map(toInsurer)
    .find((insurer) => insurer.value.toLowerCase() === 'none') || {
    label: 'Not currently insured',
    value: 'None',
  },

  mostCommonInsurerList: insurers
    .filter(
      (insurer) =>
        isMostCommon(insurer) &&
        insurer.code.toLowerCase() !== 'dontknow' &&
        insurer.code.toLowerCase() !== 'other' &&
        insurer.code.toLowerCase() !== 'none'
    )
    .sort(byCode)
    .map(toInsurer),

  otherInsurerList: insurers
    .filter(
      (insurer) =>
        !isMostCommon(insurer) &&
        insurer.code.toLowerCase() !== 'dontknow' &&
        insurer.code.toLowerCase() !== 'other' &&
        insurer.code.toLowerCase() !== 'none'
    )
    .sort(byCode)
    .map(toInsurer),
});

export const unmarshalInsurers = (
  insurers: WireRefDataTypes
): ApiData<RecentInsurerOptions> => {
  const insurerList = Object.values(insurers);
  return insurerList?.length > 0
    ? makeApiSuccess(toRecentInsurerOptions(insurerList))
    : makeApiError('Not found');
};
